module.exports = __webpack_public_path__ + "img/ai-agent.3585ec2e.svg";